<script>

import {
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";

import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";

/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
  },
  data() {
    return {
      showPassword: false,
      email: "",
      password: "",
      submitted: false,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  computed: {
    ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    ...authFackMethods,
    ...notificationMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        const { email, password } = this;
        if (email && password) {
          this.login({
            email,
            password,
          });
        }
      }
    }
  },
  mounted() { },
};
</script>

<template>
    <b-form class="p-2" @submit.prevent="tryToLogIn">
      <p class="bg-danger text-white p-2 text-center" v-if="notification.type == 'alert-danger'">Invalid Credentials</p>  
      <b-form-group
          class="mb-3"
          id="input-group-1"
          label="Email"
          label-for="input-1"
      >
        <b-form-input
            id="input-1"
            v-model="email"
            type="text"
            placeholder="Enter email"
            :class="{ 'is-invalid': submitted && $v.email.$error }"
        ></b-form-input>
        <div
            v-if="submitted && $v.email.$error"
            class="invalid-feedback"
        >
          <span v-if="!$v.email.required">Email is required.</span>
          <span v-if="!$v.email.email">Please enter valid email.</span>
        </div>
      </b-form-group>

      <b-form-group
          class="mb-3"
          id="input-group-2"
          label="Password"
          label-for="input-2"
      >

        <b-input-group>
          <b-form-input
              id="input-2"
              v-model="password"
              :type="showPassword ? 'text' : 'password'"
              placeholder="Enter password"
              :class="{ 'is-invalid': submitted && $v.password.$error }"
          ></b-form-input>
        <b-input-group-append>
            <button class="btn btn-outline-light rounded-0 rounded-right" style="border-color: #ced4da;" type="button" @click="showPassword = !showPassword">
              <i class="mdi" :class="{ 'mdi-eye-off': showPassword, 'mdi-eye': !showPassword }"></i>
            </button>
        </b-input-group-append>
      </b-input-group>

        <div
            v-if="submitted && !$v.password.required"
            class="invalid-feedback"
        >
          Password is required.
        </div>
      </b-form-group>
      <div class="mt-3 d-grid">
        <b-button type="submit" variant="primary" class="btn-block"
        >Log In</b-button
        >
      </div>
      <div class="mt-4 text-center">
        <router-link tag="a" to="/forgot-password" class="text-muted">
          <i class="mdi mdi-lock me-1"></i> Forgot your password?
        </router-link>
      </div>
    </b-form>
</template>

<style lang="scss" module></style>
